import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {useData} from '../../context/DataContext';
import {useLang} from '../../context/LanguageContext';
import { FaArrowLeft } from 'react-icons/fa';
import TitleOneCard from '../../components/cardsGeneration/titleOneCard';
import {useAuth} from "../../context/AuthContext";
import DateUtils from "../../utils/dateUtils";
import Footer from "../../components/Footer";
import GroupsAccordion from "../../components/GroupAccordion";


const GenerateManySmallOddsPage = () => {
    const navigate = useNavigate();
    const { games } = useData();
    const { t } = useLang();
    const { currentUser, hasWeeklyOnly } = useAuth();
    const user = currentUser;

    const [selectedDays, setSelectedDays] = useState([]);
    const [numberOfGames, setNumberOfGames] = useState(2);
    const [error, setError] = useState(null);
    const [groups, setGroups] = useState([]);

    const allDays = Array.from(new Set(games?.map((g) => g.day))) || [];

    const toggleDay = (day) => {
        if (selectedDays.includes(day)) {
            setSelectedDays(selectedDays.filter((d) => d !== day));
        } else {
            setSelectedDays([...selectedDays, day]);
        }
    };

    const handleGenerate = async () => {
        setError(null);

        if (!user) {
            navigate('/account');
            return;
        }

        // generarea nu este inclusa in abonamentul saptamanal
        if (hasWeeklyOnly) {
            navigate('/subscriptions');
            return;
        }

        const num = parseInt(numberOfGames, 10);
        if (selectedDays.length === 0) {
            setError(t('error.atLeastADay'));
            return;
        }
        if (!num || num <= 0) {
            setError(t('error.selectValidNumberOfGames'));
            return;
        }

        const filteredGames = games.filter((g) => selectedDays.includes(g.day));
        if (filteredGames.length < num) {
            setError(t('error.notEnoughGames'));
            return;
        }

        const generatedGroups = generateBestGroups(filteredGames, num);

        setGroups(generatedGroups)
    };

    return (
        <div className="bg-[#34495e] min-h-screen p-5 relative">
            <button
                onClick={() => navigate(-1)}
                className="absolute top-5 left-5 px-4 py-2 bg-[#2ecc71] rounded flex items-center space-x-2"
            >
                <FaArrowLeft />
                <span className="text-white">{t('btn.back')}</span>
            </button>

            <h1 className="text-xl text-white font-bold text-center mt-16 mb-8">
                {t('txt.generateManySmallOddsTitle')}
            </h1>

            <div className="mb-4">
                <TitleOneCard title={t('txt.generateCard1')} />
                <p className="text-white mb-2 font-semibold">{t('txt.selectDays')}</p>
                <div className="flex flex-wrap gap-2">
                    {allDays.map((day) => {
                        const translatedDayLabel = DateUtils.formatDayOnly(day, t);

                        return (
                            <button
                                key={day}
                                onClick={() => toggleDay(day)}
                                className={`px-3 py-1 rounded ${
                                    selectedDays.includes(day)
                                        ? 'bg-green-500 text-white'
                                        : 'bg-gray-200'
                                }`}
                            >
                                {translatedDayLabel}
                            </button>
                        );
                    })}
                </div>
            </div>

            <div className="mb-4">
                <p className="text-white mb-2 font-semibold">{t('txt.selectNumberOfGames')}</p>
                <select
                    className="w-full border p-2 rounded w-32"
                    onChange={(e) => setNumberOfGames(e.target.value)}
                    value={numberOfGames}
                >
                    {[2,3,4,5,6,7,8,9,10,11,12,13,14,15].map(nr => {
                        return (
                            <option key={nr} value={nr}>{nr}</option>
                        )
                    })}
                </select>
            </div>

            {error && <p className="text-red-500 mb-2">{error}</p>}

            <button
                onClick={handleGenerate}
                className="bg-blue-500 text-white font-bold py-2 px-4 rounded hover:bg-blue-600 transition"
            >
                {t('btn.generate')}
            </button>

            <TitleOneCard title={t('txt.generateManySmallOddsDescriptions')} />
            <div className="w-full mx-auto my-4">
            {groups.map((group, index) => {
                return <React.Fragment key={index}>
                    <GroupsAccordion group={group} index={index} />
                </React.Fragment>
            })}
            </div>
            <Footer />
        </div>
    );
};

function generateBestGroups(data, count){
    let bestGroups = [];
    for (let i = 0; i < 10; i++) {
        const shuffled = shuffleData([...data]);
        const groups = getRandomUniqueGames(shuffled, count);
        if (groups.length < bestGroups.length || bestGroups.length === 0) {
            bestGroups = groups;
        }
    }

    return bestGroups;
}

function getRandomUniqueGames(data, count) {
    const groups = [];

    let group = [];
    let usedTeams = new Set();
    let usedShopCodes = new Set();

    while(data.length > 0){
        for (let item of data) {
            if (usedShopCodes.has(item.shopCode)) continue;
            if (usedTeams.has(item.team1) && usedTeams.has(item.team2)) continue;

            group.push(item);
            usedShopCodes.add(item.shopCode);
            usedTeams.add(item.team1);
            usedTeams.add(item.team2);
            delete(data[data.findIndex(i => i===item )])

            if (group.length === count) {
                groups.push(group);
                group = [];
                usedTeams = new Set();
                usedShopCodes = new Set();
            }
        }

        data = data.filter(item => item);
        if(group.length > 0) {
            groups.push(group);
            group = [];
            usedTeams = new Set();
            usedShopCodes = new Set();
        }
    }

    return groups;
}




function shuffleData(data) {
    for (let i = data.length - 1; i > 0; i--) {
        const j = Math.floor(Math.random() * (i + 1));
        [data[i], data[j]] = [data[j], data[i]];
    }

    return data;
}

export default GenerateManySmallOddsPage;
